/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import TextColumn from "../products/TextColumn";
import {Modal} from "../../atoms/bootstrap/Modal";
import React from "react";

export function ModalWarning({roleBased, closeModal}) {
    return <Modal title={roleBased.relatedProductsOverlayTitle} closeModal={closeModal}>
        <Modal.Body className="text-center">
            <div className="row">
                <TextColumn text={roleBased.relatedProductsOverlayText}
                            btnLabel={roleBased.relatedProductsOverlayBtnText}
                            btnAction={roleBased.relatedProductsOverlayBtnLink}/>
            </div>
        </Modal.Body>
    </Modal>
}
